import { useContext, useEffect } from "react";
// my imports:
import UI from "@/app/lib/ui/ui";
import WordModule from "@/app/lib/game-state/word-module";
import LetterBox from "@/app/components/LetterBox";
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import { Contexts } from "@/app/components/Context";
import { StoryGameState } from "@/app/lib/game-state/story-game-state";
import { useAnimationTrigger } from "@/app/lib/ui/use-animation-trigger";
// styles:
import styles from "@/app/styles/wordBox.module.css";
import animation from "@/app/styles/animation.module.css"


type WordBoxProps = {
    wordIndex: number;
};

export default function WordBox({ wordIndex } : WordBoxProps) {

    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI |null = useContext(Contexts.UI)
    if (!activeGame || !ui) {
        console.warn('bad context in WordBox')
        return;
    }

    // We're gonna place acceptAnimation on its own div so it can have its own speed if we choose
    const rejectAnimation = useAnimationTrigger(`${animation.headShake} ${animation.fast}`)
    const acceptAnimation = useAnimationTrigger(`${animation.softGlow} ${animation.medium}`)
    useEffect(() => {
        ui.setRejectAnimation(wordIndex, rejectAnimation.trigger);
        ui.setAcceptAnimation(wordIndex, acceptAnimation.trigger);
    }, []);

    // we access the module directly from the parent state, essential for rendering correctly
    const wordModule: WordModule = activeGame.state.words[wordIndex];
    const renderBulletPoint: boolean = true;

    let isActiveWord = false;
    if (
        activeGame.state instanceof StoryGameState
        && !activeGame.state.completed
        && activeGame.state.currentPhase.wordIndices.includes(wordModule.index)
    ) {
        isActiveWord = true;
    }

    return (
        <div
            className={`${rejectAnimation.className} ${styles.wordBox}`}
        >
            {renderBulletPoint &&
                <div className={isActiveWord
                        ? `${styles.wordBoxBulletPoint} ${styles.activeBulletPoint}`
                        : styles.wordBoxBulletPoint
                }>
                    {
                        wordModule.solved ?
                            '●' :
                            '○'
                    }
                </div>
            }
            <div 
                className={`${acceptAnimation.className} ${styles.wordBoxLetters}`}
            >
                {wordModule.letters.map((letterModule) => 
                    <LetterBox
                        key={letterModule.position} 
                        letterPosition={letterModule.position}
                        wordIndex={wordModule.index}
                    />
                )}
            </div>
        </div>
    );
}